import Cookies from "js-cookie";

function useReadCookies () 
{
  let cookieGameId = Cookies.get("game_id");
  let game_code = Cookies.get("game_code") || '';
  let cookiePlayerId = Cookies.get("player_id");
  let cookieUsername = Cookies.get("user_name");
  let cookieGroupId = Cookies.get('group_id');

  const params = new URLSearchParams(window.location.search);
  if(params.get('demo') === 'true'){
    cookiePlayerId = Cookies.get("player_id_" + params.get('player'));
    cookieUsername = Cookies.get("user_name_"  + params.get('player'));
    game_code = undefined;
  }

  return {cookieGameId, game_code, cookiePlayerId, cookieUsername, cookieGroupId};
};

export default useReadCookies;